import React, { useState, useEffect } from 'react';
import {
  IconButton,
  Popover,
  Box,
  Button,
  Grid,
  TextField,
  Divider,
} from '@mui/material';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { useDispatch, useSelector } from 'react-redux';
import { mediumIconStyles } from '../styles/icon';
import { StyledTextField } from '../styles/textField';
import { ResponsiveTypography } from '../styles/inputLabel';
import { SmallHeading } from '../styles/smallHeading';
import { cyanBlueBackgroundButtonStyles } from '../styles/button';
import { AppDispatch, RootState } from '../Redux/store';
import { submitCustomerSupportForm } from '../Redux/Slices/Support/supportHandler';
import {
  resetSupportForm,
  updateSupportForm,
} from '../Redux/Slices/Support/support';
import CustomTooltip from './customTooltip';

function SupportForm() {
  const dispatch = useDispatch<AppDispatch>();
  const { email, message } = useSelector(
    (state: RootState) => state.customerSupport,
  );
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    dispatch(resetSupportForm());
  };

  const open = Boolean(anchorEl);

  useEffect(() => {
    async function updateURL() {
      dispatch(
        updateSupportForm({
          target: 'url',
          value: window.location.href,
        }),
      );
    }
    updateURL();
  }, []);
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        mr: '2rem',
        mb: '2rem',
      }}
    >
      <CustomTooltip title="Support" placement="top" arrow>
        <IconButton
          onClick={handleClick}
          sx={{
            backgroundColor: '#253858',
            borderRadius: '50%',
            padding: '0.5rem',
            '&:hover': {
              backgroundColor: '#2f4d73',
            },
          }}
        >
          <ContactSupportIcon sx={{ ...mediumIconStyles, color: '#fff' }} />
        </IconButton>
      </CustomTooltip>
      {/* <Tooltip title="Support" placement="top" arrow>
        <IconButton
          onClick={handleClick}
          sx={{
            backgroundColor: '#253858',
            borderRadius: '50%',
            padding: '0.5rem',
            '&:hover': {
              backgroundColor: '#2f4d73',
            },
          }}
        >
          <ContactSupportIcon sx={{ ...mediumIconStyles, color: '#fff' }} />
        </IconButton>
      </Tooltip> */}
      <Popover
        id="support-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '1rem',
            borderRadius: '1rem',
            backgroundColor: 'white',
            width: '25rem',
          }}
        >
          <Box pb="0.5rem">
            <SmallHeading>Support</SmallHeading>
            <ResponsiveTypography>
              Please fill out the form below to contact our support team.
            </ResponsiveTypography>
          </Box>
          <Divider />
          <Grid
            container
            sx={{
              rowGap: {
                xxl: '1.5rem',
                xl: '1rem',
                lg: '0.5rem',
                md: '0.5rem',
              },
            }}
            pt="1rem"
          >
            <Grid item xs={12}>
              <ResponsiveTypography variant="subtitle2">
                Email
              </ResponsiveTypography>
              <StyledTextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                name="email"
                onChange={(event: any) => dispatch(
                  updateSupportForm({
                    target: 'email',
                    value: event.target.value,
                  }),
                )}
                value={email}
              />
            </Grid>
            <Grid item xs={12}>
              <ResponsiveTypography variant="subtitle2">
                Message
              </ResponsiveTypography>
              <TextField
                required
                fullWidth
                multiline
                name="message"
                rows={3}
                maxRows={3}
                sx={{
                  '& .MuiInputBase-input': {
                    fontSize: {
                      xl: '0.938rem !important',
                      lg: '0.625rem !important',
                      md: '0.625rem !important',
                    },
                    height: {
                      xl: '4rem !important',
                      lg: '3rem !important',
                      md: '3rem !important',
                    },
                    padding: {
                      xl: 0,
                      lg: '0.25rem 0.438rem !important',
                      md: '0.25rem 0.438rem !important',
                    },
                  },
                }}
                value={message}
                onChange={(event: any) => dispatch(
                  updateSupportForm({
                    target: 'message',
                    value: event.target.value,
                  }),
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                sx={{ ...cyanBlueBackgroundButtonStyles, width: '6rem' }}
                onClick={() => {
                  dispatch(submitCustomerSupportForm()).then(() => {
                    handleClose();
                  });
                }}
              >
                Send
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Popover>
    </Box>
  );
}

export default SupportForm;
